<script lang="ts">
import type { FilterFunctionProperties, MenuItem, Nullable } from '@/types'
import { PillGroup, PillInput } from '@goodlifeplus/component-library'
import type { TIconName } from '@goodlifeplus/component-library/types'
import { type SlotsType, defineComponent } from 'vue'

export default defineComponent({
  components: {
    PillInput,
    PillGroup,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    filter: {
      type: Object as () => FilterFunctionProperties<any>,
      required: true,
    },
  },
  emits: ['updateFilter'],
  slots: Object as SlotsType<{
    default?: (props: {
      /** The menu item to display information for */
      item: MenuItem
      /** Indicates if the item is current selected */
      selected: boolean
      /** Function to update the filter to this item */
      updateFilter: (item: MenuItem) => void
    }) => any
  }>,
  data() {
    return {
      current: 0,
      pills: [],
    }
  },
  watch: {
    'filter.selectedItemCode.value': {
      handler() {
        const selectedMenuItem = this.getSelectedMenuItem()

        if (!selectedMenuItem) {
          return
        }

        void this.updateFilter(selectedMenuItem)
      },
      immediate: true,
    },
    'filter.categories.value': {
      handler() {
        const selectedMenuItem = this.getSelectedMenuItem()

        if (!selectedMenuItem) {
          return
        }

        void this.updateFilter(selectedMenuItem)
      },
      immediate: true,
    },
  },
  methods: {
    getSelectedMenuItem(): Nullable<MenuItem> {
      return (
        this.filter.categories.value.find(
          (m: MenuItem) => m.code === this.filter.selectedItemCode.value
        ) ?? null
      )
    },
    async updateFilter(menuItem: MenuItem) {
      const categoryIndex: number = this.filter.categories.value.findIndex(
        (m: MenuItem) => m.code === menuItem.code
      )

      if (categoryIndex === -1 || categoryIndex === this.current) {
        return
      }

      this.current = categoryIndex
      this.filter.setSelectedItem(menuItem)

      this.$emit('updateFilter', categoryIndex)
    },
  },
})
</script>

<template>
  <PillGroup v-model="current">
    <PillInput
      v-for="(menuItem, key) in filter.categories.value"
      :key
      :label="menuItem.text"
      :icon="menuItem.icon"
      :value="key"
      @click="filter.setSelectedItem(menuItem)"
    />
  </PillGroup>
</template>
